/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';
import StringResources from 'nls/StringResources';
import { SVGIcon, Label } from '@ba/ba-ui-carbon-toolkit';

import dataRelationships128 from '@ba/ba-graphics/dist/illustrations-js/data-relationships-card_128';

import BlankCardView from './views/BlankCardView';

import './AddNewCard.scss';

@observer
class AddNewCard extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const menuItems = this.getMenuSpec();

		return (
			<div className="explore-add-new__content">
				{menuItems}
			</div>
		);
	}

	renderItem(item, key) {
		let menuItem;
		if (item.icon) {
			const itemClassName = 'explore-add-new__content__item';
			menuItem = (
				<div
					className={itemClassName}
					onClick={() => this.onClick(item.type)}
					key={key}
					data-type={item.type}
				>
					<div className={`${itemClassName}__caption`}>
						<Label label={item.caption}/>
					</div>
					<div
						className={`${itemClassName}__starting-points-icon`}
						onKeyPress={(...params) => this.onKeyPress(item.type, ...params)}
						tabIndex={0}
					>
						<SVGIcon
							className={`${item.className ? item.className : ''}`}
							width={190}
							height={98}
							iconId={item.icon.id}
						/>
					</div>

				</div>
			);
		} else {
			menuItem = item.element(key);
		}

		return menuItem;
	}

	onClick(type) {
		this.performAction(type);
	}

	onEnter(type) {
		this.performAction(type);
	}

	onKeyPress(type, event) {
		const handler = {
			'Enter': () => this.onEnter(type)
		}[event.key];

		handler && handler();
	}

	performAction(type) {
		this.props.onClick({ type });
	}

	getMenuSpec() {
		const spec = [
			{
				caption: '',
				element: key => <Label className="explore-add-new__content__item__title" label={StringResources.get('flyout_add-new-card_title')} key={key} />,
				type: 'title'
			},
			{
				element: key => <div
					className="explore-add-new__content__item explore-add-new__content__item__single"
					onClick={() => this.onClick('single')}
				>
					<div className="explore-add-new__content__item__caption">
						<Label label={StringResources.get('flyout_add-new-card_single')} />
					</div>
					<div
						className="explore-add-new__content__item__icon"
						onKeyPress={(...params) => this.onKeyPress('single', ...params)}
						tabIndex={0}
					>
						<BlankCardView
							classPrefix={'explore-add-new__content__item__icon__card'}
							key={key}
						/>
					</div>

				</div>,
				type: 'single'
			},
			{
				element: key => <div
					className="explore-add-new__content__item explore-add-new__content__item__compare"
					onClick={() => this.onClick('compare')}
				>
					<div className="explore-add-new__content__item__caption">
						<Label label={StringResources.get('flyout_add-new-card_compare')} />
					</div>
					<div
						className="explore-add-new__content__item__icon"
						onKeyPress={(...params) => this.onKeyPress('compare', ...params)}
						tabIndex={0}
					>
						<BlankCardView
							classPrefix={'explore-add-new__content__item__icon__card'}
							key={`${key}_1`}
						/>
						<BlankCardView
							classPrefix={'explore-add-new__content__item__icon__card'}
							key={`${key}_2`}
						/>
					</div>
				</div>,
				type: 'compare'
			},
			{
				caption: StringResources.get('startingPoints_data_relationships_thumbnail_title'),
				icon: dataRelationships128,
				className: 'startingPointsThumb',
				type: 'startingPoints'
			}
		];

		const excluded = this.props.excluded;
		let displayedItems = spec;
		if (excluded.length > 0) {
			displayedItems = spec.filter(item => excluded.indexOf(item.type) === -1);
		}
		return displayedItems.map((item, index) => this.renderItem(item, index));
	}
}

AddNewCard.propTypes = {
	onClick: PropTypes.func,
	excluded: PropTypes.array
};

AddNewCard.defaultProps = {
	onClick: () => {},
	excluded: []
};

export default AddNewCard;



// WEBPACK FOOTER //
// ./src/js/components/cards/AddNewCard.js